<template>
  <div class="sm:hidden" :class="{ block: block }" aria-hidden="true">
    <div class="py-2">
      <div class="border-t border-gray-200"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    block: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
